//#region src/punchh_printer_barcode_type.ts
var PunchhPrinterBarcodeType = /* @__PURE__ */ function(PunchhPrinterBarcodeType) {
	PunchhPrinterBarcodeType["BarcodeMap1"] = "barcode-map-1";
	PunchhPrinterBarcodeType["BarcodeMap1Short"] = "barcode-map-1-short";
	PunchhPrinterBarcodeType["BarcodeMap2"] = "barcode-map-2";
	PunchhPrinterBarcodeType["BarcodeMap3"] = "barcode-map-3";
	PunchhPrinterBarcodeType["QR"] = "qr";
	PunchhPrinterBarcodeType["None"] = "none";
	return PunchhPrinterBarcodeType;
}(PunchhPrinterBarcodeType || {});
//#endregion
export { PunchhPrinterBarcodeType };

//# sourceMappingURL=punchh_printer_barcode_type.js.map